const CLOUDFRONT_LANDING_PAGE_ROOT_URL = 'https://d2rwz7a7lb9mw2.cloudfront.net/landingpage';

const limited_time_offer_banner_v2 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/optimized-png/limited_time_offer_banner_v2.png`;
const vuz_vip_p_en = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/vuz_vip_p_en.svg`;
const vuz_vip_p_ar = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/vuz_vip_p_ar.svg`;

const ads_journey_header_logo = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/png/vuz_logo_u1.png`;
const visitors_badge = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/png/visitors_badge_1.png`;

const benefit_new_1 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/benefit_new_1.svg`;
const benefit_new_2 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/benefit_new_2.svg`;
const benefit_new_3 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/benefit_new_3.svg`;
const benefit_new_4 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/benefit_new_4.svg`;
const benefit_new_5 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/benefit_new_5.svg`;
const benefit_new_raffle = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/ic_ticket_raffle.svg`;
const benefit_new_6 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/benefit_new_6.svg`;

const blue_fire_u = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/blue_fire_u.svg`;
const blue_diamond_u = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/blue_diamond_u.svg`;
const blue_medal_u = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/blue_medal_u.svg`;
const diamond_bonuses_u = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/diamond_bonuses_u.svg`;
const raffle_ticket_gold = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/raffle_ticket_gold.svg`;

const arrow_right_chevron = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/arrow_right_chevron.svg`;
const arrow_right_medium = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/arrow_right_medium.svg`;
const arrow_right_small = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/arrow_right_small.svg`;
const background_blur_ellipse_large = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/background_blur_ellipse_large.svg`;
const background_blur_ellipse_small = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/background_blur_ellipse_small.svg`;
const limited_time_offer_header_v2 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/limited_time_offer_header_v2.svg`;
const vip_badge_inline = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/vip_badge_inline.svg`;

const user_icon_1 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/png/user_icon_1u1.png`;
const user_icon_2 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/png/user_icon_2u1.png`;
const user_icon_3 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/png/user_icon_3u1.png`;
const user_icon_4 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/png/user_icon_4u1.png`;

export const Icons = {
  limited_time_offer_banner_v2,
  vuz_vip_p_en,
  vuz_vip_p_ar,

  ads_journey_header_logo,
  visitors_badge,

  benefit_new_1,
  benefit_new_2,
  benefit_new_3,
  benefit_new_4,
  benefit_new_5,
  benefit_new_6,
  benefit_new_raffle,

  blue_fire_u,
  blue_diamond_u,
  blue_medal_u,
  diamond_bonuses_u,
  raffle_ticket_gold,

  user_icon_1,
  user_icon_2,
  user_icon_3,
  user_icon_4,

  arrow_right_chevron,
  arrow_right_medium,
  arrow_right_small,
  background_blur_ellipse_large,
  background_blur_ellipse_small,
  limited_time_offer_header_v2,
  vip_badge_inline,
};
